import { useMutation, useQuery } from '@tanstack/react-query'
import { complianceApi } from '@/services/compliance'
import type { AccountDeletionRequest, ConsentRequest } from '@/types'

const KEY = 'compliance'

export function usePrivacyPolicy() {
  return useQuery({
    queryKey: [KEY, 'privacy-policy'],
    queryFn: () => complianceApi.getPrivacyPolicy(),
  })
}

export function useRecordConsent() {
  return useMutation({
    mutationFn: (body: ConsentRequest) => complianceApi.recordConsent(body),
  })
}

export function useCookieConfig() {
  return useQuery({
    queryKey: [KEY, 'cookie-config'],
    queryFn: () => complianceApi.getCookieConfig(),
  })
}

export function useRecordCookieConsent() {
  return useMutation({
    mutationFn: (body: ConsentRequest) =>
      complianceApi.recordCookieConsent(body),
  })
}

export function useRequestAccountDeletion() {
  return useMutation({
    mutationFn: (body: AccountDeletionRequest) =>
      complianceApi.requestAccountDeletion(body),
  })
}
